import { render, staticRenderFns } from "./DrawWidget.vue?vue&type=template&id=408d9340&lang=true"
import script from "./DrawWidget.vue?vue&type=script&lang=js"
export * from "./DrawWidget.vue?vue&type=script&lang=js"
import style0 from "./DrawWidget.vue?vue&type=style&index=0&id=408d9340&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports